import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListFilterComponent } from './list-filter.component';
import { MaterialsModule } from '../../modules/material.module';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SearchModule } from '../search/search.module';

@NgModule({
  declarations: [ListFilterComponent],
  imports: [
    CommonModule,
    FormsModule,
    MaterialsModule,
    ScrollingModule,
    SearchModule,
    MatProgressSpinnerModule,
    TranslateModule.forChild(),
  ],
  exports: [ListFilterComponent],
})
export class ListFilterModule {}
